import { AxiosHelper } from "../axiosConfig";
import APIConstant from "../utils/apiConstant";

export const getGrade = (params) => {
  return AxiosHelper.axiosInstance().get(APIConstant.CMS_GRADE_ALL, {
    params: {
      gradeId: params.gradeId,
      name: params.name,
      abbreviation: params.abbreviation,
      orderByColumn: params.orderByColumn,
      sortDir: params.sortDir,
      PageSize: params.pageSize,
      PageNumber: params.pageNumber,
    },
  });
};

export const getAllgrade = (pageSize = 100, pageNumber = 1) => {
  return AxiosHelper.axiosInstance().get(APIConstant.CMS_GRADE_ALL, {
    params: {
      PageSize: pageSize,
      PageNumber: pageNumber,
    },
  });
};

export const postGrade = (gradeInput) => {
  return AxiosHelper.axiosInstance().post(
    APIConstant.CMS_GRADE,
    gradeInput,
    {}
  );
};

export const deleteGradeSection = (deleteGradeId) => {
  return AxiosHelper.axiosInstance().delete(APIConstant.CMS_GRADE, {
    params: {
      id: deleteGradeId,
    },
  });
};

export const updateGradeSection = (updategrade) => {
  return AxiosHelper.axiosInstance().put(
    APIConstant.CMS_GRADE,
    updategrade,
    {}
  );
};

export const getGradeState = () => {
  return AxiosHelper.axiosInstance().get(APIConstant.CMS_STATE, {
    params: {
      PageSize: 100,
      PageNumber: 1,
    },
  });
};

export const getGradeGrade = () => {
  return AxiosHelper.axiosInstance().get(APIConstant.CMS_GRADE, {
    params: {
      PageSize: 20,
      PageNumber: 1,
    },
  });
};

export const getGradeSubjects = () => {
  return AxiosHelper.axiosInstance().get(APIConstant.CMS_CONTENT_AREA_ALL, {
    params: {
      PageSize: 100,
      PageNumber: 1,
    },
  });
};

export const getGradeByStandardId = (standardId: number) => {
  return AxiosHelper.axiosInstance().get(APIConstant.CMS_GRADESTANDARD, {
    params: {
      standardId: standardId,
    },
  });
};

export const getGradeById = (id) => {
  return AxiosHelper.axiosInstance().get(
    `${APIConstant.CMS_GRADE_BY_ID}/${id}`
  );
};
